<script>
export default {
  name: 'ClaroControleFacilApp',
  beforeCreate () {
    try {
      const version = process.env.VUE_APP_VERSION
      const isProd = process.env.VUE_APP_MODE === 'production'
      const hasMock = process.env.VUE_APP_AUTOSERVICO_API_MOCK === 'on'
      const env = isProd ? '' : `%c ${process.env.VUE_APP_MODE}`
      const mock = hasMock ? '%c MOCK ON' : ''

      console.log(...[ // eslint-disable-line
        `%c Claro Controle %c v${version} ${env}${mock} %c`,
        'background:#d52b1e ; padding: 3px; color: #fff; border-radius: 3px 0 0 3px;',
        `background:#e0a800 ; padding: 3px; color: #000; ${(isProd || hasMock) ? 'border-radius: 0 3px 3px 0;' : ''}`,
        isProd ? false : `background:#000; padding: 3px; color: #fff; ${!hasMock ? 'border-radius: 0 3px 3px 0;' : ''}`,
        !hasMock ? false : 'background:#696969; padding: 3px; color: #fff; border-radius: 0 3px 3px 0;',
        'background:transparent;'
      ].filter(Boolean))
    } catch (e) {
      // Catch vazio para descartar possíveis erros de navegadores para o log da versao acima
    }
  }
}
</script>

<template>
  <div id="app">
    <router-view />
    <notifications position="top center" width="90%" :max=3>
      <template slot="body" slot-scope="{ item }">
        <div class="notification">
          <div class="border-2 border-white mdn-Alert mdn-Alert--success mdn-Alert--dark mdn-isOpen">
            <div class="mdn-Tag mdn-Tag--feedback">
              <div class="mdn-Alert-content">
                <em class="mdn-Tag-icon mdn-Icon-checkbox-circulo mdn-Icon--sm"></em>
                <p id="comp-pix-notification-title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>
